/* import __COLOCATED_TEMPLATE__ from './kiosk.hbs.js'; */
import Component from '@glimmer/component';
export default class Kiosk extends Component {
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
  get width() {
    return this.args.width || 24;
  }
  get height() {
    return this.args.height || 24;
  }
}